import { render, staticRenderFns } from "./GuardianOfChild.vue?vue&type=template&id=372370f9"
import script from "./GuardianOfChild.vue?vue&type=script&lang=ts"
export * from "./GuardianOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports